// extracted by mini-css-extract-plugin
var _1 = "F2mMlhIVE0";
export { _1 as "root" }
